export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_l_01_f_mask.f4867aa6.png";